import { useTemplate } from "PFApp/hooks";
import { EmptyState } from "PFComponents/empty_state";
import NoProfilesIllustration from "PFTheme/graphics/illustrations/illustration-no-profiles.svg";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./matches_empty/matches_empty.module.scss";

type MatchesActivityClosedProps = { activity: Activity };

export const MatchesActivityClosed = ({ activity }: MatchesActivityClosedProps) => {
  const { t } = useTranslation("activities");
  const { name } = activity;

  const template = useTemplate(activity.template_id);
  const templateName = template?.name;

  return (
    <div className={css.emptyStateContainer}>
      <EmptyState
        illustration={<NoProfilesIllustration className={css.noProfilesIcon} />}
        message={t("show.matches.activityClosed", { name, templateName })}
      />
    </div>
  );
};
